<template>
  <el-dialog
    append-to-body
    width="500px"
    :title="currentRow ? '编辑锁价商品' : '新增锁价商品'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    @open="handleOpen"
    center
  >
    <el-form
      ref="elFormDom"
      label-position="right"
      label-width="100px"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      class="center-form"
    >
      <el-form-item
        label="供应商:"
        prop="supplier_id"
        class="center-item"
        v-if="!currentRow"
      >
        <el-select
          v-model="form.data.supplier_id"
          filterable
          @change="handleSupplierSelect"
          id="bind_id"
          clearable
          placeholder="请输入"
        >
          <el-option
            v-for="item in supplierArr"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商:" class="center-item" v-if="currentRow">
        {{ currentRow.name }}
      </el-form-item>
      <el-form-item label="锁价期限:" prop="lock_date" class="center-item">
        <el-date-picker
          v-model="form.data.lock_date"
          type="daterange"
          align="right"
          :disabled="getLockDateDisabled()"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          class="selDaterangeWidth"
          :clearable="false"
          id="date"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="商品名称:"
        prop="good_name"
        class="center-item"
        v-if="!currentRow"
      >
        <el-select
          v-model="form.data.good_name"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          @change="handleGoodSelect"
          :loading="selLoading"
          value-key="id"
        >
          <el-option
            v-for="item in goodArr"
            :label="item.good_name"
            :value="item"
            :key="item.id"
            :disabled="item.sold_out == 1 ? true : false"
          >
            <div class="flex" style="justify-content: space-between">
              <div>
                <span style="float: left">{{ item.good_name }}</span>
              </div>
              <span style="color: #8492a6; font-size: 13px"
                >{{ item.unit_name }} / {{ item.name }}</span
              >
            </div>
            <div style="color: #999; margin-top: -5px" v-if="!!item.norm_name">
              标名：{{ item.norm_name }}
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="单位:"
        prop="unit_name"
        class="center-item"
        v-if="!currentRow"
      >
        {{ form.data.unit_name }}
      </el-form-item>
      <el-form-item
        label="规格:"
        prop="name"
        class="center-item"
        v-if="!currentRow"
      >
        {{ form.data.name }}
      </el-form-item>
      <el-form-item
        label="锁定金额:"
        prop="amount"
        class="center-item"
        v-if="!currentRow"
      >
        <el-input
          v-money
          size="mini"
          v-model.trim="form.data.amount"
          placeholder="请输入"
          clearable
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  props: ["supplierArr"],
  data() {
    return {
      visible: false,
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      form: {
        loading: false,
        data: {
          supplier_id: "",
          lock_date: [],
          amount: "",
          spec_id: "",
        },
        rules: {
          supplier_id: [
            {
              required: true,
              message: "请选择供应商",
              trigger: "change",
            },
          ],
          lock_date: [
            {
              type: "array",
              required: true,
              message: "请选择锁价期限",
              trigger: "change",
            },
          ],
          good_name: [
            {
              required: true,
              message: "请选择商品",
              trigger: "change",
            },
          ],
          amount: [
            {
              required: true,
              message: "请输入锁定金额",
              trigger: "change",
            },
          ],
        },
      },
      goodArr: [], // 商品列表
      selLoading: false,
      currentRow: null,
      supplierArrLock: [],
    };
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        let _params = {
          page: 1,
          count: 1000,
          status: 1,
          good_name: query,
          // merchant_id: this.form.data.supplier_id,
          // address_id: this.form.data.address_id,
        };
        this.selLoading = true;
        this.$http
          .get("/admin/goods/specList", { params: _params })
          .then((res) => {
            if (res.code === 1) {
              this.goodArr = res.data.list;
            }
          })
          .finally(() => {
            this.selLoading = false;
          });
      } else {
        this.goodArr = [];
      }
    },
    handleGoodSelect(item) {
      console.log(item);
      this.form.data.unit_name = item.unit_name;
      this.form.data.name = item.name;
      this.form.data.spec_id = item.id;
    },
    reset(done) {
      this.currentRow = null;
      this.form.data = {
        supplier_id: "",
        lock_date: [],
        amount: "",
        spec_id: "",
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      if (show) {
        this.getLockSupplier();
      }
      !show && this.reset();
    },
    //用于查锁价的供应商枚举
    getLockSupplier() {
      this.$http
        .get("/admin/lock/list", {
          params: { status: 1, page: 1, count: 10000 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.supplierArrLock = res.data.list;
          }
        });
    },
    getLockDateDisabled() {
      let obj = this.supplierArrLock.find(
        (item) => item.id === this.form.data.supplier_id
      );
      if (!this.currentRow) {
        return Boolean(obj || !this.form.data.supplier_id);
      } else {
        return Boolean(obj);
      }
    },
    handleSupplierSelect(val) {
      let obj = this.supplierArrLock.find((item) => item.id === val);
      if (obj) {
        this.form.data.lock_date = [obj.lock_start, obj.lock_end];
      } else {
        this.form.data.lock_date = [];
        this.$nextTick(() =>{
          this.$refs.elFormDom.clearValidate("lock_date");
        })
      }
    },
    close() {
      this.toggle(false);
    },
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.elFormDom.clearValidate();
      });
    },
    getDetail(row) {
      this.currentRow = row;
      this.form.data.lock_date = [row.lock_start, row.lock_end];
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (this.currentRow) {
            this.eddConfirm();
          } else {
            this.addConfirm();
          }
        }
      });
    },
    addConfirm() {
      let params = {
        ...this.form.data,
        lock_start: this.form.data.lock_date[0],
        lock_end: this.form.data.lock_date[1],
      };
      this.form.loading = true;
      this.$http
        .post("/admin/lock/createOrUpdate", params)
        .then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.$emit("confirm");
            this.toggle(false);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
    eddConfirm() {
      let params = {
        id: this.currentRow.id,
        lock_start: this.form.data.lock_date[0],
        lock_end: this.form.data.lock_date[1],
      };
      this.form.loading = true;
      this.$http
        .post("/admin/lock/edit", params)
        .then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.$emit("confirm");
            this.toggle(false);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.center-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-item {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.el-select,
.el-date-picker {
  width: 100%;
}
</style>

